module.exports = __webpack_public_path__ + "static/media/mevanPiyasena.9520b78a.jpg";